/* Masaüstü kategori menüsü (snippets/mega-menu.liquid).
   Fare: üzerine gelince kısa gecikmeyle açılır, menüden çıkınca kapanır; sol listede kategori değişimi
   çapraz fare hareketinde yanlışlıkla atlamasın diye kısa gecikmeli. Dokunmatik: ilk dokunuş açar, ikincisi
   bağlantıya gider. Klavye: ↓ veya Boşluk açar ve panele odaklar, Escape kapatır. */
(() => {
  if (customElements.get('mega-menu')) return;
  const OPEN_DELAY = 90, CLOSE_DELAY = 220, SWITCH_DELAY = 110;
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const desktop = window.matchMedia('(min-width: 768px)');

  class MegaMenu extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.panel = this.querySelector('[data-mm-panel]');
      this.triggers = Array.from(this.querySelectorAll('[data-mm-trigger]'));
      this.cats = Array.from(this.querySelectorAll('[data-mm-cat]'));
      this.panes = Array.from(this.querySelectorAll('[data-mm-pane]'));
      if (!this.panel || !this.triggers.length) return;
      this.current = null;
      this.timers = {};
      this.backdrop = document.createElement('div');
      this.backdrop.className = 'mm-backdrop';
      this.backdrop.setAttribute('aria-hidden', 'true');
      document.body.appendChild(this.backdrop);

      this.triggers.forEach(trigger => {
        const key = trigger.dataset.mmTrigger;
        trigger.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse' || !canHover.matches) return;
          this.clear('close');
          this.schedule('open', () => this.open(key), this.current ? 0 : OPEN_DELAY);
        });
        trigger.addEventListener('pointerleave', () => this.clear('open'));
        trigger.addEventListener('click', event => {
          // Dokunmatik veya farenin hover desteklemediği durumda ilk dokunuş paneli açar.
          if (canHover.matches && event.pointerType !== 'touch') return;
          if (this.current === key) return;
          event.preventDefault();
          this.open(key);
        });
        trigger.addEventListener('keydown', event => {
          if (event.key === 'ArrowDown' || event.key === ' ') {
            event.preventDefault();
            this.open(key);
            const first = this.activePane() && this.activePane().querySelector('a');
            if (first) first.focus();
          }
        });
      });
      this.querySelectorAll('[data-mm-plain]').forEach(link => {
        link.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') this.schedule('close', () => this.close(), 60); });
      });
      this.cats.forEach(cat => {
        const key = cat.dataset.mmCat;
        cat.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse') return;
          this.schedule('switch', () => this.show(key), SWITCH_DELAY);
        });
        cat.addEventListener('pointerleave', () => this.clear('switch'));
        cat.addEventListener('focus', () => this.show(key));
        cat.addEventListener('click', event => {
          if (canHover.matches && event.pointerType !== 'touch') return;
          if (cat.classList.contains('is-active')) return;
          event.preventDefault();
          this.show(key);
        });
      });
      this.addEventListener('pointerenter', () => this.clear('close'));
      this.addEventListener('pointerleave', event => {
        if (event.pointerType !== 'mouse') return;
        this.clear('open');
        this.schedule('close', () => this.close(), CLOSE_DELAY);
      });
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) this.close(); });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || !this.current) return;
        const trigger = this.trigger(this.current);
        this.close();
        if (trigger) trigger.focus();
      });
      this.onDocClick = event => { if (this.current && !this.contains(event.target)) this.close(); };
      this.onMedia = () => { if (!desktop.matches) this.close(); };
      this.onPageHide = () => this.close();
      document.addEventListener('click', this.onDocClick);
      desktop.addEventListener('change', this.onMedia);
      window.addEventListener('pagehide', this.onPageHide);
      this.backdrop.addEventListener('click', () => this.close());
    }
    disconnectedCallback() {
      Object.keys(this.timers || {}).forEach(name => this.clear(name));
      if (this.onDocClick) document.removeEventListener('click', this.onDocClick);
      if (this.onMedia) desktop.removeEventListener('change', this.onMedia);
      if (this.onPageHide) window.removeEventListener('pagehide', this.onPageHide);
      if (this.backdrop) this.backdrop.remove();
      this.ready = false;
    }
    schedule(name, fn, delay) {
      this.clear(name);
      if (!delay) { fn(); return; }
      this.timers[name] = window.setTimeout(() => { delete this.timers[name]; fn(); }, delay);
    }
    clear(name) {
      if (this.timers[name]) { window.clearTimeout(this.timers[name]); delete this.timers[name]; }
    }
    trigger(key) { return this.triggers.find(t => t.dataset.mmTrigger === key); }
    activePane() { return this.panes.find(p => !p.hidden); }
    open(key) {
      if (!desktop.matches) return;
      this.clear('close');
      this.panel.hidden = false;
      this.backdrop.classList.add('is-visible');
      this.show(key);
    }
    show(key) {
      if (!this.panes.some(p => p.dataset.mmPane === key)) return;
      this.clear('switch');
      this.current = key;
      this.panes.forEach(p => { p.hidden = p.dataset.mmPane !== key; });
      this.cats.forEach(c => c.classList.toggle('is-active', c.dataset.mmCat === key));
      this.triggers.forEach(t => {
        const on = t.dataset.mmTrigger === key && !this.panel.hidden;
        t.classList.toggle('is-open', on);
        t.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    }
    close() {
      ['open', 'close', 'switch'].forEach(name => this.clear(name));
      if (!this.current && this.panel.hidden) return;
      this.current = null;
      this.panel.hidden = true;
      this.backdrop.classList.remove('is-visible');
      this.triggers.forEach(t => { t.classList.remove('is-open'); t.setAttribute('aria-expanded', 'false'); });
    }
  }
  customElements.define('mega-menu', MegaMenu);
})();
